<template>
  <div id="pageProperty">
    <a-row class="pageProperty-btn" type="flex" justify="start">
      <a-col>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t("generic.Refresh") }}</span>
          </template>
          <img style="margin-left: 10px;" @click="iniFreshTable('resh')" class="sbxs" src="../../../assets/img/ss-refresh.png"  width="22" height="22">
        </a-tooltip>
      </a-col>
    </a-row>
    <a-row v-if="pagePropertylist.length != 0">
      <a-col :span="4" style="height: 80vh;overflow-y: auto">
        <draggable class="list-group" :list="pagePropertylist" >
          <div
              class="list-group-item"
              v-for="(element) in pagePropertylist"
              :class="{'active':leftTarget == element.FieldName}"
              :key="element.FieldName"
          >
            <a-row type="flex" justify="start">
              <a-col>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Disaplyable</span>
                  </template>
                  <a-switch size="small" v-model="element.Disaplyable"/>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Edit</span>
                  </template>
                  <a-switch class='ml4' size="small" v-model="element.Editable"/>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Mandatory</span>
                  </template>
                  <a-switch class='ml4' size="small" v-model="element.Mandatory"/>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Search</span>
                  </template>
                  <a-switch class='ml4' size="small"  v-model="element.Searchable"/>
                </a-tooltip>
              </a-col>
            </a-row>
            <a-row type="flex" justify="start" class="sbxs" >
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ element.FieldName }}</span>
                </template>
               <span @click="listClick(element)" style="text-decoration:underline">{{ element.FieldName }}</span>
              </a-tooltip>
            </a-row>
          </div>
        </draggable>
      </a-col>
      <a-col :span="19" class="ml4">
        <a-tabs  v-model="propertyTabsActive" @change="propertabsChange">
          <a-tab-pane key="1" :tab="leftTarget">
            <a-form :form="form">
              <a-row>
                <a-divider orientation="left">Display Setting</a-divider>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.ShowTitleSeq')" v-bind="formItemLayout">
                    <a-input-number
                        :min="1"
                        size="small"
                        style="width: 100%"
                        v-decorator="[
                        'showTitleSeq',
                          { initialValue: editTargetPagePro.showTitleSeq }
                        ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Width')" v-bind="formItemLayout">
                    <a-input-number
                      style="width: 100%;"
                      size="small"
                      :placeholder="$t('generic.Width')"
                      :min="1"
                      v-decorator="[
                          'proWidth',
                          {
                            initialValue: editTargetPagePro.proWidth
                          }
                        ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.DataFormat')" v-bind="formItemLayout">
                    <a-input
                          :placeholder="$t('generic.DataFormat')"
                          v-decorator="[
                        'dataFormat',
                        {
                          initialValue:
                            editTargetPagePro.dataFormat == null
                              ? undefined
                              : editTargetPagePro.dataFormat
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Statistics')" v-bind="formItemLayout">
                    <a-select
                        allowClear
                        style="width: 100%"
                        size="small"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        v-decorator="[
                          'statistics',
                          {
                            initialValue: editTargetPagePro.statistics
                          }
                        ]">
                      <a-select-option value="SUM">SUM</a-select-option>
                      <a-select-option value="Count">Count</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.IsShowTitle')" v-bind="formItemLayout">
                    <a-switch
                        size="small"
                        v-decorator="[
                            'isShowTitle',
                            {
                              valuePropName: 'checked',
                              initialValue: editTargetPagePro.isShowTitle
                            }
                          ]"
                    />
                  </a-form-item>
                </a-col>
                <a-divider orientation="left">Parameter Setting</a-divider>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.DefaultValue')" v-bind="formItemLayout">
                    <a-select
                        style="width: 100%"
                        size="small"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        allowClear
                        v-decorator="[
                          'extentionValueType',
                          {
                            initialValue:
                              editTargetPagePro.extentionValueType == null
                                ? undefined
                                : editTargetPagePro.extentionValueType
                          }
                        ]"
                    >
                      <a-select-option
                              v-for="(item, index) in extentionValueType"
                              :key="index"
                              :value="item.key"
                      >
                        {{ item.value }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.GenIdtype')" v-bind="formItemLayout">
                    <a-input
                          size="small"
                          :placeholder="$t('generic.GenIdtype')"
                          v-decorator="[
                               'genIdType',
                            {
                              initialValue:
                              editTargetPagePro.genIdType == null
                              ? undefined
                              : editTargetPagePro.genIdType
                              }
                            ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.FieldType')" v-bind="formItemLayout">
                    <a-select
                        :placeholder="$t('publicLang.PleaseSelect')"
                        style="width: 100%"
                        size="small"
                        allowClear
                        v-decorator="[
                          'fieldType',
                          {
                            initialValue:
                              editTargetPagePro.fieldType == null
                                ? undefined
                                : editTargetPagePro.fieldType
                          }
                        ]"
                    >
                      <a-select-option key="DROP">Dropdown</a-select-option>
                      <a-select-option key="LOOKUP">Lookup</a-select-option>
                      <a-select-option key="POPUP">Popup</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Isitunique')" v-bind="formItemLayout">
                    <a-switch
                        size="small"
                        v-decorator="[
                            'uniquable',
                            {
                              valuePropName: 'checked',
                              initialValue:
                                editTargetPagePro.uniquable === '1' ? true : false
                            }
                          ]"
                    />
                  </a-form-item>
                </a-col>
                <a-divider orientation="left">Field Mapping Setting</a-divider>
                <a-col :span="12" v-if="editTargetPagePro.displayOption">
                  <a-form-item :label="$t('generic.OptionType')" v-bind="formItemLayout">
                    <a-select
                        style="width: 100%"
                        size="small"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        allowClear
                        v-decorator="[
                          'isOption',
                          {
                            initialValue:
                              editTargetPagePro.isOption === null
                                ? undefined
                                : editTargetPagePro.isOption
                          }
                        ]"
                    >
                      <a-select-option
                              v-for="(item, index) in isOptionArr"
                              :key="index"
                              :value="item.key"
                      >
                        {{ item.value }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
                    <a-cascader
                        allowClear
                        size="small"
                        :fieldNames="{
                          label: 'moduleCode',
                          value: 'key',
                          children: 'children'
                          }"
                            :options="pageProModules"
                            expandTrigger="hover"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-model="pageproModuleModel"
                      />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.MapToModule')"v-bind="formItemLayout">
                    <a-cascader
                          allowClear
                          size="small"
                          :fieldNames="{
                            label: 'moduleCode',
                            value: 'key',
                            children: 'children'
                          }"
                          :options="pageproMaoToModules"
                          expandTrigger="hover"
                          :placeholder="$t('publicLang.PleaseSelect')"
                          v-model="pageproMaoToModel"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.FieldMap')" v-bind="formItemLayout">
                    <a-select
                        allowClear
                        size="small"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        @dropdownVisibleChange="dropdownVisibleChange"
                        v-decorator="[
                            'mapUid',
                            {
                              initialValue: editTargetPagePro.mapUid
                            }
                          ]"
                    >
                      <a-select-option
                              v-for="(item, index) in FormFieldMapList"
                              :key="index"
                              :value="item.fieldMapUid"
                      >{{ item.mapName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item :label="$t('generic.FieldPattern')" :labelCol="{ span: 4 }">
                    <div style="display: flex;align-items: center">
                      <a-textarea
                              :placeholder="$t('generic.FieldPattern')"
                              :rows="3"
                              style="width:70%"
                              disabled
                              :value="JSON.stringify(pageProPatterJson)"
                      />
                      <img  @click="editFieldPatterJson" class="sbxs mllr4" src="../../../assets/img/ss-add.png"  width="22" height="22">
                      <img  @click="clearFieldPatter" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <a-row type="flex" justify="end">
              <a-button type="primary" @click="submitPagePro" size="small">{{ $t('publicLang.Save') }}</a-button>
            </a-row>
          </a-tab-pane>
          <a-tab-pane key="2" tab="Field Pattern" force-render>
            <a-form :form="pageProPatternForm">
              <a-row :gutter="24">
                <a-divider orientation="left">Generic Binding</a-divider>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
                    <a-cascader
                            :fieldNames="{
                          label: 'moduleCode',
                          value: 'key',
                          children: 'children'
                        }"
                            :options="gmcuidModule"
                            expandTrigger="hover"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-model="ConfigGmcModule"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Function')" v-bind="formItemLayout">
                    <a-select
                            style="width: 100%"
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-model="ConfigGmcFunction"
                    >
                      <a-select-option
                              v-for="(item, index) in gmcuidfunction"
                              :value="item.functionKey"
                              :key="index"
                      >{{ item.functionValue }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.GenericName')" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            @dropdownVisibleChange="genericNameVisibleChange"
                            v-decorator="[
                  'gmcUid',
                  { initialValue: pageProPatterJson.gmcUid }
                ]"
                    >
                      <a-select-option
                              v-for="(item, index) in gmcuidGeneric"
                              :value="item.uid"
                              :key="index"
                      >{{ item.name }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.GenericParameters')" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="[
                  'params',
                  {
                    initialValue:
                      pageProPatterJson.params == null
                        ? []
                        : pageProPatterJson.params,
                    rules: [{ type: 'array' }]
                  }
                ]"
                            mode="multiple"
                    >
                      <a-select-option
                              v-for="(item, index) in ParametersList"
                              :value="item.detailUid"
                              :key="index"
                      >{{ item.FieldName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-divider orientation="left">Action Setting</a-divider>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.DefaultSelected')" v-bind="formItemLayout">
                    <a-switch
                            v-decorator="[
                  'defaultSelected',
                  {
                      initialValue: pageProPatterJson.defaultSelected,
                      valuePropName: 'checked'
                  }
                ]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.IsReserveAdmin')" v-bind="formItemLayout">
                    <a-switch
                            v-decorator="[
                    'reserveAdmin',
                    {
                        initialValue: pageProPatterJson.reserveAdmin,
                        valuePropName: 'checked'
                    }
                ]"/>
                  </a-form-item>
                </a-col>
                <a-divider orientation="left">Trigger Event</a-divider>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.TriggerFields')" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            mode="multiple"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-model="computeJson.transmitParams">
                      <a-select-option
                              v-for="(item, index) in ParametersList"
                              :value="item.detailUid"
                              :key="index"
                      >{{ item.FieldName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.IsTrigger')" v-bind="formItemLayout">
                    <a-switch v-model="computeJson.configChange" @change="computeJsonIsChange"/>
                  </a-form-item>
                </a-col>
                <a-divider orientation="left">Caculation Formular</a-divider>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.CalcParameters')" v-bind="formItemLayout">
                    <a-select
                            size="small"
                            allowClear
                            mode="multiple"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-model="computeJson.computeMultiple"
                    >
                      <a-select-option
                              v-for="(item, index) in ParametersList"
                              :value="item.detailUid"
                              :key="index"
                      >{{ item.FieldName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.CalcType')" v-bind="formItemLayout">
                    <a-select
                            style="width: 100%"
                            v-model="computeJson.computeTypeTop"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            allowClear>
                      <a-select-option value="+">+</a-select-option>
                      <a-select-option value="*">*</a-select-option>
                      <a-select-option value="/">/</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.SurfixParameter')" v-bind="formItemLayout">
                    <a-input-number
                            style="width: 100%"
                            v-model="computeJson.computeTypeNum"
                            :placeholder="$t('generic.SurfixParameter')"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.CalcType')" v-bind="formItemLayout">
                    <a-select
                            style="width: 100%"
                            v-model="computeJson.computeTypeBtm"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            allowClear>
                      <a-select-option value="+">+</a-select-option>
                      <a-select-option value="*">*</a-select-option>
                      <a-select-option value="/">/</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="12" v-if="false">
                  <a-form-item :label="$t('generic.UniqueParameter')" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            mode="multiple"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="[
                  'uniqueParams',
                  {
                    initialValue:
                      pageProPatterJson.uniqueParams == null
                        ? []
                        : pageProPatterJson.uniqueParams,
                    rules: [{ type: 'array' }]
                  }
                ]"
                    >
                      <a-select-option
                              v-for="(item, index) in ParametersList"
                              :value="item.detailUid"
                              :key="index"
                      >{{ item.FieldName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="false">
                  <a-form-item :label="$t('generic.Depend')" v-bind="formItemLayout">
                    <a-select
                            style="width: 100%"
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="[
                  'dependOn',
                  {
                    initialValue: parseInt(pageProPatterJson.dependOn)
                  }
                ]"
                    >
                      <a-select-option
                              v-for="(item, index) in ParametersList"
                              :value="item.detailUid"
                              :key="index"
                      >{{ item.FieldName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="false">
                  <a-form-item :label="$t('generic.Condition')" v-bind="formItemLayout">
                    <a-select
                            style="width: 100%"
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="[
                  'condition',
                  {
                    initialValue: pageProPatterJson.condition
                  }
                ]"
                    >
                      <a-select-option value="<"> < </a-select-option>
                      <a-select-option value="="> = </a-select-option>
                      <a-select-option value=">"> > </a-select-option>
                      <a-select-option value="<>"> <> </a-select-option>
                      <a-select-option value=">="> >= </a-select-option>
                      <a-select-option value="<="> <= </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="false">
                  <a-form-item :label="$t('generic.IsDefType')" v-bind="formItemLayout">
                    <a-select
                            style="width: 100%"
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="[
                  'isDefType',
                  {
                    initialValue: pageProPatterJson.isDefType
                  }
                ]"
                    >
                      <a-select-option value="Date"> Date </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <a-row type="flex" justify="end">
              <a-button type="primary" @click="getFiledPatterJson">{{ $t('publicLang.Save') }}</a-button>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>
    <a-row  v-else>
      <a-empty>
        <span slot="description"> {{ $t('pubGicSet.NoRecordfound') }}</span>
      </a-empty>
    </a-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import draggable from "vuedraggable"
export default {
  components: {
      draggable
  },
  computed: {
      columns(){
          return [
              {
                  title: this.$t('generic.FieldName'),
                  dataIndex: "FieldName",
                  width: 100,
                  scopedSlots: { customRender: "FieldName" }
              },
              {
                  width: 100,
                  title: this.$t('generic.Disaplyable'),
                  dataIndex: "Disaplyable",
                  scopedSlots: { customRender: "Disaplyable" }
              },
              {
                  width: 100,
                  title: this.$t('generic.Editable'),
                  scopedSlots: { customRender: "Editable" },
                  dataIndex: "Editable"
              },
              {
                  width: 100,
                  title: this.$t('generic.Searchable'),
                  scopedSlots: { customRender: "Searchable" },
                  dataIndex: "Searchable"
              },
              {
                  title: this.$t('generic.Mandatory'),
                  dataIndex: "Mandatory",
                  scopedSlots: { customRender: "Mandatory" },
                  width: 100
              },
              {
                  width: 100,
                  title: this.$t('generic.DefaultValue'),
                  scopedSlots: { customRender: "DefaultValue" },
                  dataIndex: "DefaultValue"
              },
              {
                  width: 100,
                  title: this.$t('generic.FieldPattern'),
                  scopedSlots: { customRender: "FieldPattern" },
                  dataIndex: "FieldPattern"
              },
              {
                  width: 100,
                  title:  this.$t('generic.Group'),
                  scopedSlots: { customRender: "sectionName" },
                  dataIndex: "sectionName"
              },
              {
                  width: 100,
                  title: this.$t('generic.Action'),
                  scopedSlots: { customRender: "operation" }
              }
          ]
      },
      ...mapState(["uid"]) // 获取uid
  },
  watch: {
    uid(val) {
        this.iniFreshTable()
    }
  },
  props: {
    pagedbSelectList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      propertyTabsActive: '1',
      leftTarget: null,
      computeJson:{
          computeMultiple: undefined,
          computeTypeTop: undefined,
          computeTypeNum: '',
          computeTypeBtm: undefined,
          configChange: false,
          transmitParams: undefined
      },
      form: this.$form.createForm(this),
      pageProPatternForm: this.$form.createForm(this),
      maskClosable: false, // 取消点击遮罩取消
      tabelText: {
        emptyText: "No record found"
      }, // table 编辑内容
      isOptionArr: [
        { key: "0", value: "key" },
        { key: "1", value: "value" },
        { key: "2", value: "empty" }
      ], // Option Type data
      scopedSlotsArray: [
        "FieldName",
        "Mandatory",
        "Disaplyable",
        "Searchable",
        "Editable",
        "DefaultValue",
        "FieldPattern",
        "sectionName"
      ], // table slot
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      visible: false, // 弹窗add edit flag
      Nopagination: false, // 取消分页
      selectedRowKeys: [], // table check选下标
      checkrows: [], // table 选中的list
      pagePropertylist: [], // table data
      editTargetPagePro: {}, // 编辑当条数据
      extentionValueType: [],
      pageProPatterJson: {}, // 配置pageproJson

      configPatterVis: false,
      gmcuidModule: [], // Filed Pattern module 下拉数据
      ConfigGmcModule: [], // Filed Pattern module 选中的items
      ConfigGmcFunction: undefined, // Filed Pattern Function 下拉数据
      gmcuidfunction: [], // Filed Pattern Function 下拉选中的值
      gmcuidGeneric: [], // Generic Name 下拉数据
      ParametersList: [], // Filed Pattern Parameters 下拉数据
      pageProModules: [],
      pageproModuleModel: [],
      pageproMaoToModules: [],
      pageproMaoToModel: [],
      FormFieldMapList: []
    };
  },
  created() {
    this.iniFreshTable();
  },
  methods: {
//      请求table数据 获取dbschema中schemaUids提交
      iniFreshTable(type){
          let pagedbSelectList = this.pagedbSelectList;
          let schemaUids = [];
//          DB schemar如果有选中的数据
          if (type === "resh") {
              for (let i in pagedbSelectList) {
                  schemaUids.push(pagedbSelectList[i].schemaUid);
              }
          }
          let schemaParas = {
              schemaUids: schemaUids,
              uid: this.uid
          };
          ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
              this.pagePropertylist = res.data;
              if(this.pagePropertylist.length == 0){
                  return
              }
              for(let i in this.pagePropertylist){
                  this.pagePropertylist[i].Disaplyable = this.pagePropertylist[i].Disaplyable == '0' ? false : true
                  this.pagePropertylist[i].Editable = this.pagePropertylist[i].Editable == '0' ? false : true
                  this.pagePropertylist[i].Mandatory = this.pagePropertylist[i].Mandatory == '0' ? false : true
                  this.pagePropertylist[i].Searchable = this.pagePropertylist[i].Searchable == '0' ? false : true
              }
              this.listClick(this.pagePropertylist[0])
          });
      },
//      点击左边编辑
      listClick(element){
          this.form.resetFields();
          this.leftTarget = element.FieldName // 编辑选中样式active

          ajax.get(api.GETMODULEDROPDATA).then(res => {
              this.pageProModules = res.data;
              this.pageproMaoToModules = res.data;
          });
          this.pageproModuleModel = [];
          this.pageproMaoToModel = [];
          this.dropdownVisibleChange();
          ajax.get(api.EXTENTIONVALUETYPE).then(res => {
              this.extentionValueType = res.data;
          });
          console.log(element);
          this.editTargetPagePro = element;
          this.pageProPatterJson = this.editTargetPagePro.FieldPattern == null ? {} : this.editTargetPagePro.FieldPattern;
          this.computeJson = this.pageProPatterJson.computeJson != undefined ? this.pageProPatterJson.computeJson: {}
      },
//      FieldMap 下拉数据
      dropdownVisibleChange() {
          let params = {
              fromModuleCode: this.pageproModuleModel[1],
              toModuleCode: this.pageproMaoToModel[1]
          };
          ajax.get(api.DROPFIELMAP, params).then(res => {
              this.FormFieldMapList = res.data;
          });
      },
//      编辑提交
      submitPagePro(){
          this.form.validateFields((err, val) => {
              let params = val;
              params.detailUid = this.editTargetPagePro.detailUid;
              params.genericUid = this.uid;
              params.schemaUid = this.editTargetPagePro.SchemaUid;
              params.uniquable = params.uniquable ? "1" : "0";
              params.fieldPattern = this.pageProPatterJson;
              ajax.post(api.SAVEPROPERTYDETAIL, params).then(res => {
                  if (res.code === 200) {
                      this.iniFreshTable();
                  }
              });
          });
      },

//      FieldPattern start
      genericNameVisibleChange() {
          let params = {
              functionCode: this.ConfigGmcFunction,
              moduleCode: this.ConfigGmcModule[0],
              subModuleCode: this.ConfigGmcModule[1]
          };
          ajax.post(api.POSTFETCH, params).then(res => {
              this.gmcuidGeneric = res.data;
          });
      },
      propertabsChange(val){
          if(val == 2){
              this.editFieldPatterJson()
          }
      },
      editFieldPatterJson(){
          this.ConfigGmcModule = [];
          this.ConfigGmcFunction = undefined;
          ajax.get(api.GETMODULEDROPDATA).then(res => {
              this.gmcuidModule = res.data;
          });
          ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
              this.gmcuidfunction = res.data;
          });

          let schemaParas = {
              schemaUids: [],
              uid: this.uid
          };
          ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
              this.ParametersList = res.data;
          });
          this.genericNameVisibleChange();
          this.propertyTabsActive = '2'
      },
//      清空 FieldPatter 配置
      clearFieldPatter(){
          this.pageProPatterJson = {};
      },
//      保存Fieldpatter配置
      getFiledPatterJson(){
          this.pageProPatternForm.validateFields((err, val) => {
              let getConfigJson = {};
              let gmcName = undefined;
              if (val.gmcUid != undefined) {
                  for (let ii in this.gmcuidGeneric) {
                      if (this.gmcuidGeneric[ii].uid == val.gmcUid) {
                          gmcName = this.gmcuidGeneric[ii].name;
                      }
                  }
              }
              getConfigJson = val;
              getConfigJson.gmcName = gmcName;
              getConfigJson.computeJson = this.computeJson
              this.pageProPatterJson = getConfigJson;
              this.pageProPatternForm.resetFields();
              this.gmcuidGeneric = [];
              this.propertyTabsActive = '1'
          });
      },
      computeJsonIsChange(val){
          this.computeJson.configChange = val
      },
  }
};
</script>
<style lang="less">
#pageProperty {
  margin-top: 10px;
  padding-bottom: 30px;
  .pageProperty-btn {
    margin-bottom: 10px;
    button {
      margin-right: 10px;
    }
  }
}
.active{
  background: #1890ff;
  color: #fff;
}
</style>
